import { Check } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Checkbox } from '@my2n/react-hook-form-inputs';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { FilledInfoBar } from '../../../../components/_DesignSystemWrappers/InfoBar/FilledInfoBar';
import { PasswordInput } from '../../../../components/HookFormFields/PasswordInput';
import messages from './messages';
import { useAccountActivationForm } from './useAccountActivationForm';
import { FormFieldNames } from './validationScheme';

export interface IActivateAccountFormProps {
  onSuccess: () => void;
}

export function AccountActivationForm(props: IActivateAccountFormProps) {
  const { email, formData, isLoading, isPasswordHelperTextVisible, onFormSubmit } = useAccountActivationForm({
    onSuccess: props.onSuccess,
  });

  return (
    <FormProvider {...formData}>
      <form onSubmit={formData.handleSubmit(onFormSubmit)}>
        <Stack direction="column" mb={3} spacing={3}>
          <FilledInfoBar>
            <Typography sx={{ wordWrap: 'break-word' }}>
              <FormattedMessage values={{ userEmail: email }} {...messages.ImsActivateAccountInfo} />
            </Typography>
          </FilledInfoBar>
          <PasswordInput
            helperText={isPasswordHelperTextVisible && <FormattedMessage {...messages.ImsNewPasswordInputHelperText} />}
            id="new-password"
            fullWidth
            label={<FormattedMessage {...messages.ImsNewPasswordInputLabel} />}
            name={FormFieldNames.Password}
            required
          />
          <Box
            sx={{
              '& .MuiCheckbox-root': {
                pt: 0,
              },
              label: {
                alignItems: 'flex-start',
              },
            }}
          >
            <Checkbox
              id="feedback-checkbox"
              label={
                <Typography>
                  <FormattedMessage {...messages.imsActivateAccountFeedbackConsentLabel} />
                </Typography>
              }
              name="feedback"
            />
          </Box>
        </Stack>
        <Button
          color="primary"
          disabled={!formData.formState.isValid}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isLoading}
          loadingPosition="start"
          startIcon={<Check />}
        >
          <FormattedMessage {...messages.ImsActivateAccountConfirm} />
        </Button>
      </form>
    </FormProvider>
  );
}
